module.exports = __webpack_public_path__ + "static/img/ai-customer-service.7e99227.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ai-customer-service.png
// module id = mrWL
// module chunks = 1